var __vue_exports__, __vue_options__
var __vue_styles__ = {}

/* styles */
require("!!vue-style-loader!css-loader?sourceMap!vue-loader/lib/style-rewriter?id=data-v-bfae3738&scoped=true!vue-loader/lib/selector?type=styles&index=0!./WebViewer.vue")

/* script */
__vue_exports__ = require("!!babel-loader!vue-loader/lib/selector?type=script&index=0!./WebViewer.vue")

/* template */
var __vue_template__ = require("!!vue-loader/lib/template-compiler?id=data-v-bfae3738!vue-loader/lib/selector?type=template&index=0!./WebViewer.vue")
__vue_options__ = __vue_exports__ = __vue_exports__ || {}
if (
  typeof __vue_exports__.default === "object" ||
  typeof __vue_exports__.default === "function"
) {
if (Object.keys(__vue_exports__).some(function (key) { return key !== "default" && key !== "__esModule" })) {console.error("named exports are not supported in *.vue files.")}
__vue_options__ = __vue_exports__ = __vue_exports__.default
}
if (typeof __vue_options__ === "function") {
  __vue_options__ = __vue_options__.options
}
__vue_options__.__file = "C:\\Users\\Simona\\Source\\Repos\\TrackadoPoc\\TrackadoIntelligence\\wwwroot\\Scripts\\components\\WebViewer.vue"
__vue_options__.render = __vue_template__.render
__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
__vue_options__._scopeId = "data-v-bfae3738"

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-bfae3738", __vue_options__)
  } else {
    hotAPI.reload("data-v-bfae3738", __vue_options__)
  }
})()}
if (__vue_options__.functional) {console.error("[vue-loader] WebViewer.vue: functional components are not supported and should be defined in plain js files using render functions.")}

module.exports = __vue_exports__



//////////////////
// WEBPACK FOOTER
// ./Scripts/components/WebViewer.vue
// module id = 37
// module chunks = 1